module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/modal_red-d6ed58ab0b96c46304531ee14b2da0c7.svg";